import { render, staticRenderFns } from "./LawActivityForm.vue?vue&type=template&id=2054ffa4&"
import script from "./LawActivityForm.vue?vue&type=script&lang=js&"
export * from "./LawActivityForm.vue?vue&type=script&lang=js&"
import style0 from "./LawActivityForm.vue?vue&type=style&index=0&id=2054ffa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports